import React from 'react';

import { BottomSectionProps } from '@/modules/common/components/templates/data-reconciliation/components/parts/data-reconciliation-bottom-section';
import { EntityReconciliationStep } from '@/modules/data-reconciliation/pages/entity-reconciliation-step';
import { useTeamReconciliationConfig } from '@/modules/onboarding/team-setup/config/team-reconciliation-config';

export interface TeamReconciliationStepProps {
  isInfiniteSizeTable?: boolean;
  onClickNext: () => void;
  bottomSection: (props: BottomSectionProps) => React.ReactNode;
  /** Reports dirty state changes (true when there are unsaved entity modifications) */
  onDirtyChange?: (isDirty: boolean) => void;
}

export const TeamReconciliationStep: React.FC<TeamReconciliationStepProps> = ({
  onClickNext,
  bottomSection,
  isInfiniteSizeTable,
  onDirtyChange,
}) => {
  const config = useTeamReconciliationConfig();

  return (
    <EntityReconciliationStep
      config={config}
      onClickNext={onClickNext}
      bottomSection={bottomSection}
      isInfiniteSizeTable={isInfiniteSizeTable}
      onDirtyChange={onDirtyChange}
    />
  );
};
